/* eslint-disable no-useless-escape */

// ########
// CAUTION: When using special characters, such as those in REGEX,
// Ensure they are properly escaped. Use \\ for correct escaping.
export const DEFAULT_RULE_FILE = `# -*- mode: yaml -*-
# This example configuration for provides basic automations to get started with gitStream.
# View the gitStream quickstart for more examples: https://docs.gitstream.cm/examples/
manifest:
  version: 1.0

automations:
  # Add a label that indicates how many minutes it will take to review the PR.
  estimated_time_to_review:
    if:
      - true
    run:
      - action: add-label@v1
        args:
          label: "{{ calc.etr }} min review"
          color: {{ colors.red if (calc.etr >= 20) else ( colors.yellow if (calc.etr >= 5) else colors.green ) }}

  # Inform PR authors when they fail to reference Jira tickets in the PR title or description.
  label_missing_jira_info:
    if:
      - {{ not (has.jira_ticket_in_title or has.jira_ticket_in_desc) }}
    run:
      - action: add-label@v1
        args:
          label: "missing-jira"
          color: {{ colors.red }}
      - action: add-comment@v1
        args:
          comment: |
            This PR is missing a Jira ticket reference in the title or description.
            Please add a Jira ticket reference to the title or description of this PR.

  # Post a comment that lists the best experts for the files that were modified.
  explain_code_experts:
    if:
      - true
    run:
      - action: explain-code-experts@v1 
        args:
          gt: 10

# +----------------------------------------------------------------------------+
# | Custom Expressions                                                         |
# | https://docs.gitstream.cm/how-it-works/#custom-expressions                 |
# +----------------------------------------------------------------------------+

calc:
  etr: {{ branch | estimatedReviewTime }}

has:
  jira_ticket_in_title: {{ pr.title | includes(regex=r/\\b[A-Za-z]+-\\d+\\b/) }}
  jira_ticket_in_desc: {{ pr.description | includes(regex=r/atlassian.net\\/browse\\/\\w{1,}-\\d{3,4}/) }}

colors:
  red: 'b60205'
  yellow: 'fbca04'
  green: '0e8a16'
`;

export const CODE_REVIEW_RULE_FILE = `# -*- mode: yaml -*-

manifest:
  version: 1.0

automations:
  linearb_ai_review:
    if:
      - {{ pr.author | match(list=['github-actions', 'dependabot', '[bot]']) | nope }}
    run:
      - action: code-review@v1
`;

export const PR_DESCRIPTION_RULE_FILE = `# -*- mode: yaml -*-

manifest:
  version: 1.0

automations:
  linearb_ai_description:
    if:
      - {{ pr.author | match(list=['github-actions', 'dependabot', '[bot]']) | nope }}
    run:
      - action: describe-changes@v1
        args:
          concat_mode: append
`;

export const PR_DESCRIPTION_ADVANCED_RULE_FILE = `# -*- mode: yaml -*-

manifest:
  version: 1.0

automations:
  linearb_ai_description:
    if:
      - {{ IS_NOT_A_BOT }}
    run:
      - action: describe-changes@v1
        args:
          concat_mode: append
          guidelines: {{ GUIDELINES }}
          template: {{ TEMPLATE_2 | dump }}

IS_NOT_A_BOT: {{ pr.author | match(list=['github-actions', 'dependabot', '[bot]']) | nope }}

GUIDELINES: |
  Make sure all relevant fields in the template are filled out.
  Attempt to extract the Jira ticket ID from either the branch name ("{{ branch.name }}") or the PR title ("{{ pr.title }}").
  If a valid Jira ticket is found, include a link to it using the format https://linearb.atlassian.net/browse/LINBEE-XXXXX
  If no ticket is found, remove the Jira link section entirely.

TEMPLATE_1: {{ ".github/pull_request_template.md" | readFile() }}
TEMPLATE_2: |
  - [🎫 LINBEE-XXXXX](https://linearb.atlassian.net/browse/LINBEE-XXXXX)

  **Changes**

  - ---- ADD CHANGE HERE ----

  **How to test it?**

  - ---- DESCRIBE HOW YOU TESTED IT? ----

  **Version Type**
  - [ ] Patch
  - [ ] Minor
  - [ ] Major
`;

export const LINEARB_AI_RULE_FILE = `# -*- mode: yaml -*-

manifest:
  version: 1.0

automations:
  linearb_ai_review:
    if:
      - {{ IS_NOT_A_BOT }}
    run:
      - action: code-review@v1

  linearb_ai_description:
    if:
      - {{ IS_NOT_A_BOT }}
    run:
      - action: describe-changes@v1

IS_NOT_A_BOT: {{ pr.author | match(list=['github-actions', 'dependabot', '[bot]']) | nope }}
`;

// keep this const as we will add here the default example
export const DEFAULT_PULL_REQUEST_URL = '';

export const KEYS_TO_REMOVE_FROM_REPO = [
  'data_service',
  'git_to_provider_user',
  'pr_author',
  'provider'
];

export const Validators = {
  FiltersValidator: 'FiltersValidator',
  ActionsValidator: 'ActionsValidator',
  FileStructureValidator: 'FileStructureValidator',
  SavedWordsValidator: 'SavedWordsValidator',
  ContextVariableValidator: 'ContextVariableValidator',
  AutomationNamesValidator: 'AutomationNamesValidator'
};
